import React from 'react';
import "./dominos.css";

import trexTarget from './assets/trex-image/trex.fset';
import trexModel from './assets/scene.gltf';

export default function Dominos() {
  return (
    <div className="Dominos">
      {/* add code to this page and update dominoes button to this endpoint if you would like
      the dominoes page to not go directly to the ar experience */}
    </div>
  );
}